<template>
  <div
    v-if="moneyAccount && moneyAccount.money_account_holder"
    class="cmp-settings-invoice-project-details-money-account-details"
  >
    <dl style="padding-left: 180px; border-bottom: 1px solid var(--sprt-85)">
      <dt
        v-if="moneyAccount.money_account_holder"
        v-text="moneyAccount.money_account_holder"
      ></dt>
      <dt v-if="moneyAccount.bank_name" v-text="moneyAccount.bank_name"></dt>
      <dt v-if="moneyAccount.account_no" v-text="moneyAccount.account_no"></dt>
      <dt v-if="moneyAccount.sort_code" v-text="moneyAccount.sort_code"></dt>
      <dt v-if="moneyAccount.swift" v-text="moneyAccount.swift"></dt>
      <dt v-if="moneyAccount.iban" v-text="moneyAccount.iban"></dt>
    </dl>
  </div>
</template>
<script>
// import { defaultTextFieldConfig } from "../../../../plugins/text-field";

export default {
  components: {},
  data() {
    return {
      // textFieldConfig: defaultTextFieldConfig(),
    };
  },
  props: {
    moneyAccount: {
      required: true,
    },
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.cmp-settings-invoice-project-details-hints {
  .variable-table {
    width: 100%;
    padding: 5px;
    th {
      text-align: left;
      padding: 5px;
    }
    td {
      padding: 5px;
    }
    tbody {
      td:first-child {
        // font-weight: 600;
      }
    }
    tr {
      height: 25px;
    }
  }
}
</style>